import { createSlice } from "@reduxjs/toolkit";
const initialPropertyState = {
  property: {
    data: {},
    loading: false,
    error: null,
  },
  listProperties: {
    data: [],
    loading: false,
    error: null,
  },
  featuredProperty: {
    data: [],
    loading: false,
    error: null,
  },
  latestProperties: {
    data: [],
    loading: false,
    error: null,
  },
  consignProperty: {
    name: null,
    email: null,
    phone: null,
    address: null,
    propertyType: null,
    comments: null,
    loading: false,
    error: null,
  },
};

const propertySlice = createSlice({
  name: "property",
  initialState: initialPropertyState,
  reducers: {
    startLoadingProperty(state) {
      state.property.error = null;
      state.property.loading = true;
    },
    loadProperty(state, action) {
      state.property.data = action.payload;
    },
    stopLoadingProperty(state) {
      state.property.loading = false;
    },
    errorProperty(state, action) {
      state.property.error = action.payload;
    },
    setConsignPropertyName(state, action) {
      state.consignProperty.name = action.payload;
    },
    setConsignPropertyEmail(state, action) {
      state.consignProperty.email = action.payload;
    },
    setConsignPropertyPhone(state, action) {
      state.consignProperty.phone = action.payload;
    },
    setConsignPropertyAddress(state, action) {
      state.consignProperty.address = action.payload;
    },
    setConsignPropertyPropertyType(state, action) {
      state.consignProperty.propertyType = action.payload;
    },
    setConsignPropertyComments(state, action) {
      state.consignProperty.comments = action.payload;
    },
    startLoadingConsignProperty(state) {
      state.consignProperty.error = null;
      state.consignProperty.loading = true;
    },
    stopLoadingConsignProperty(state) {
      state.consignProperty.loading = false;
    },
    errorConsignProperty(state, action) {
      state.consignProperty.error = action.payload;
    },
    clearConsignDataPropertyForm(state) {
      state.consignProperty.name = null;
      state.consignProperty.email = null;
      state.consignProperty.phone = null;
      state.consignProperty.address = null;
      state.consignProperty.propertyType = null;
      state.consignProperty.comments = null;
    },
    loadListProperties(state, action) {
      state.listProperties.data = action.payload;
    },
    startLoadingListProperties(state) {
      state.listProperties.error = null;
      state.listProperties.loading = true;
    },
    stopLoadingListProperties(state) {
      state.listProperties.loading = false;
    },
    errorListProperties(state, action) {
      state.listProperties.error = action.payload;
    },
    loadFeaturedProperty(state, action) {
      state.featuredProperty.data = action.payload;
    },
    startLoadingFeaturedProperty(state) {
      state.featuredProperty.error = null;
      state.featuredProperty.loading = true;
    },
    stopLoadingFeaturedProperty(state) {
      state.featuredProperty.loading = false;
    },
    featuredPropertyError(state, action) {
      state.featuredProperty.error = action.payload;
    },
    loadLatestProperties(state, action) {
      state.latestProperties.data = action.payload;
    },
    startLoadingLatestProperties(state) {
      state.latestProperties.error = null;
      state.latestProperties.loading = true;
    },
    stopLoadingLatestProperties(state) {
      state.latestProperties.loading = false;
    },
    latestPropertiesError(state, action) {
      state.latestProperties.error = action.payload;
    },
  },
});

export const propertyActions = propertySlice.actions;

export default propertySlice.reducer;
